import { ethers } from "ethers";
import { getProvider } from "./eoa/provider";
import ERC20ABI from "./abi/ERC20.json";
import { env } from "~/env";
import DpPoolABI from "~/utils/web3/abi/DpPool.json";
import FactoryABI from "~/utils/web3/abi/Factory.json";

export const getFrontDPContract = () => {
  const provider = getProvider();

  return new ethers.Contract(
    env.NEXT_PUBLIC_DP_TOKEN_ADDRESS,
    ERC20ABI,
    provider,
  );
};

export const getERC20Contract = (
  address: string,
  provider?: ethers.Signer | ethers.JsonRpcApiProvider,
) => {
  return new ethers.Contract(address, ERC20ABI, provider);
};

/**
 * @description amount는 ether 단위
 */
export const getApproveCalldata = (
  contract: ethers.Contract,
  spender: string,
  amount: string | number,
) => {
  // const value = BigInt(Number(amount) * 10 ** 18);
  const value = ethers.parseUnits(amount.toString(), 18);
  const data = contract.interface.encodeFunctionData("approve", [
    spender,
    value,
  ]);

  return data;
};

/**
 * @description amount는 ether 단위
 */
export const getTransferCalldata = (
  contract: ethers.Contract,
  to: string,
  amount: string | number,
) => {
  // const value = BigInt(Number(amount) * 10 ** 18);
  const value = ethers.parseUnits(amount.toString(), 18);
  const data = contract.interface.encodeFunctionData("transfer", [to, value]);

  return data;
};

export const getDpBalance = async (
  contract: ethers.Contract,
  address: string,
) => {
  const balance: bigint | undefined = await contract.balanceOf?.(address);
  return balance?.toString();
};

export const getTransparentFactoryContract = (
  address: string,
  signer?: ethers.Signer,
) => {
  return new ethers.Contract(address, FactoryABI, signer);
};

export const getDpPoolContract = (
  contractAddress: string,
  provider?: ethers.JsonRpcApiProvider | ethers.Signer,
) => {
  return new ethers.Contract(contractAddress, DpPoolABI, provider);
};

export const createDpPoolContractCalldata = (
  contract: ethers.Contract,
  owner: string,
  tokenAddress: string,
) => {
  const data = contract.interface.encodeFunctionData("initialize", [
    owner,
    tokenAddress,
  ]);
  return data;
};
